import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addSubCategory, deleteSubCategory, getAllSubCategory, updateSubCategory } from '../../redux/rtk/features/masters/subCategorySlice';
import PageTitle from '../page-header/PageHeader';


const SubCategoryMaster = () => {
  const { Title } = Typography;


  const [editingSubCategory, setEditingSubCategory] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.subCategory);

  useEffect(() => {
    dispatch(getAllSubCategory());
  }, [dispatch]);


  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingSubCategory) {
        // Update existing category
        const result = await dispatch(
          updateSubCategory({ id: editingSubCategory.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllSubCategory());
        } else {
          message.error('Error updating category!');
        }
      } else {
        // Add new category
        const result = await dispatch(addSubCategory(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllSubCategory());
        } else {
          message.error('Error adding category!');
        }
      }
      form.resetFields();
      setEditingSubCategory(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      message.error('Failed to add or update category!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteSubCategory(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllSubCategory()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Sub-Category',
      dataIndex: 'subCategoryName',
      key: 'name',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {
            setEditingSubCategory(record);
            form.setFieldsValue(record);
          }}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this sub-category?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
        <Card title={editingSubCategory ? 'Edit Sub-Category' : 'Add Sub-Category'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="sub-category-form"
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
      
          <Form.Item
            name="subCategoryName"
            label="Sub-Category"
            rules={[{ required: true, message: 'Please enter a Sub-Category!' }]}
          >
            <Input placeholder="Enter Sub-Category" />
          </Form.Item>
          <Button type="primary" block htmlType="submit">
                {editingSubCategory ? 'Update Sub-Category' : 'Add Sub-Category'}
              </Button>
            </Form>
        </Card>
        </Col>
        <Col span={16}>
          <Card title="Sub-Categories List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
        </Row>
    </div>
  );
};

export default SubCategoryMaster;
